<template>
  <el-dialog title="追溯码采集" :visible.sync="showTraceabilityCode"
             :before-close="closeDialog" top="80px" class="info-dialog">
    <el-alert type="warning" show-icon :closable="false">
      <div>1. 只需采集中西成药和器械追溯码;</div>
      <div>2. 拆零药品采集对应大包装的追溯码;</div>
      <div>3. 包装上无追溯码则无需采集;</div>
    </el-alert>
    <template v-if="traceabilityList.orderItemDrugList.length">
      <h4 style="margin-top: 20px">中西成药:</h4>
      <el-table :data="traceabilityList.orderItemDrugList" :header-cell-style="{ 'font-weight': 'bold' }"
                style="width: 100%; margin: 0 0 20px 0;" class="table">
        <el-table-column label="药品名称" prop="drugName" width="160px"></el-table-column>
        <el-table-column label="数量" prop="dosage" width="80px">
          <template slot-scope="scope">
            {{ scope.row.dosage }} {{ scope.row.saleUnit }}
          </template>
        </el-table-column>
        <el-table-column label="追溯码" prop="tracCodeList">
          <template slot-scope="{ row }">
            <div style="display: flex; flex-wrap: wrap;">
              <template  v-for="(item, index) in row.tracCodeList">
                <el-input :key="index" v-model="row.tracCodeList[index]"
                          :style="{width: (item && item.length * 10 || 10) + 48 + 'px'}"
                          style="padding: 0 3px 3px 0;"
                          clearable
                          @input="changePrevTraceabilityCode(row, index)"
                ></el-input>
              </template>
              <el-input v-if="row.tracCodeList.length < row.dosage" class="traceability-input" placeholder="扫描或输入追溯码"
                        :style="{ width: (row.newTraceabilityCode && row.newTraceabilityCode.length > 12 ?
                      row.newTraceabilityCode.length * 10 : 120) + 32 + 'px' }"
                        v-model="row.newTraceabilityCode" @keyup.enter.native="setTraceabilityCode(row)"
                        @blur="setTraceabilityCodeBlur(row)" @input="handleInput(row)" :maxlength="20"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="traceabilityList.orderItemDiagnosisDetailList.length" >
      <h4 style="margin-top: 20px">医疗器械:</h4>
      <el-table :data="traceabilityList.orderItemDiagnosisDetailList" :header-cell-style="{ 'font-weight': 'bold' }"
                style="width: 100%; margin: 0 0 20px 0;" class="table">
        <el-table-column label="项目名称" prop="hiProjectName" width="160px"></el-table-column>
        <el-table-column label="数量" prop="dosage" width="80px">
          <template slot-scope="scope">
            {{ scope.row.dosage }} {{ scope.row.saleUnit }}
          </template>
        </el-table-column>
        <el-table-column label="追溯码" prop="tracCodeList">
          <template slot-scope="{ row }">
            <div style="display: flex; flex-wrap: wrap;">
              <template  v-for="(item, index) in row.tracCodeList">
                <el-input :key="index" v-model="row.tracCodeList[index]"
                          :style="{width: (item && item.length * 10 || 10) + 48 + 'px'}"
                          style="padding: 0 3px 3px 0;"
                          clearable
                          @input="changePrevTraceabilityCode(row, index)"
                ></el-input>
              </template>
              <el-input v-if="row.tracCodeList.length < row.dosage" class="traceability-input" placeholder="扫描或输入追溯码"
                        :style="{ width: (row.newTraceabilityCode && row.newTraceabilityCode.length > 12 ?
                      row.newTraceabilityCode.length * 10 : 120) + 32 + 'px' }"
                        v-model="row.newTraceabilityCode" @keyup.enter.native="setTraceabilityCode(row)"
                        @blur="setTraceabilityCodeBlur(row)" @input="handleInput(row)" :maxlength="20"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <div class="traceability-dialog-footer" ref="dialogFooterBtnRef">
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button @click="closeDialog">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "TraceabilityCodeDialog",
  data() {
    return {
      showTraceabilityCode: false,
      traceabilityList: {
        orderItemDrugList: [],
        orderItemDiagnosisDetailList: [],
      },
      keyList: ['orderItemDrugList', 'orderItemDiagnosisDetailList']
    }
  },
  methods: {
    handleInput(row) {
      // 只允许输入纯数字
      row.newTraceabilityCode = row.newTraceabilityCode.replace(/\D/g, '');
    },
    againOpenDialog(obj) {
      let _v = JSON.parse(JSON.stringify(obj))

      // for (const item of v) {
      //   item.tracCodeList = [item.tracCode]
      //   item.newTraceabilityCode = '' // 新加的追溯码输入框
      // }

      for (let i = 0; i < this.keyList.length; i++) {

        let v = _v[this.keyList[i]].filter(item => {
          item.itemId = item.id
          item.tracCodeList = item.tracCode ? item.tracCode.split(',') : []
          item.newTraceabilityCode = '' // 新加的追溯码输入框
          item.feeType = this.keyList[i] == 'orderItemDrugList' ? item.drugType : '5'
          return (item.hiProjectCode || item.hiMedListCodg)
        })

        this.traceabilityList[this.keyList[i]] = v
      }

      this.showTraceabilityCode = true

    },

    async submit() {

      let { orderItemDrugList, orderItemDiagnosisDetailList } = this.traceabilityList

      let traceabilityList = [...orderItemDrugList, ...orderItemDiagnosisDetailList]


      let flag = traceabilityList.every(v => v.tracCodeList.length == v.dosage)

      console.log(flag, this.$attrs.traceCodeRequired)
      if (!flag && this.$attrs.traceCodeRequired == 1) {
        return this.$message({
          message: '追溯码输入数量有误,请扫描或者填写追溯码！',
          type: 'error',
        });
      }
      try {
        let data = {
          orderNo: traceabilityList[0].orderNo,
          tracCodeList: traceabilityList
        }
        let isValidLength = traceabilityList.every(item => {
          return item.tracCodeList.every(val => val.length == 20)
        });
        if (!isValidLength) {
          this.$message({
            message: '追溯码格式错误！',
            type: 'warning',
          });
          return;
        }

        await this.$api.traceabilityCode.saveTraceabilityCode(data)
        this.$message({
          message: '保存成功！',
          type: 'success',
        });
        this.showTraceabilityCode = false
        this.$emit('getTraceabilityList')
      } catch (e) {
        console.log(e)
      }
    },

    closeDialog() {
      console.log(this.traceabilityList,'+++++++++++')
      this.showTraceabilityCode = false
    },
    setTraceabilityCode(row) {
      if (!row.newTraceabilityCode) {
        return this.$message({
          type: "error",
          message: '追溯码不能为空!',
        });
      }
      row.tracCodeList.push(row.newTraceabilityCode)
      row.newTraceabilityCode = ''
    },
    setTraceabilityCodeBlur(row) {
      if (!row.newTraceabilityCode) {
        return
      }
      row.tracCodeList.push(row.newTraceabilityCode)
      row.newTraceabilityCode = ''
    },
    changePrevTraceabilityCode(row, index) {
      row.tracCodeList[index] = row.tracCodeList[index].replace(/\D/g, '')
      row.tracCodeList = row.tracCodeList && row.tracCodeList.length ? row.tracCodeList : []
      row.tracCodeList = row.tracCodeList.filter(v => !!v == true)
    }
  },

}
</script>

<style scoped lang="scss">
.traceability-input {
  width: 150px;
  padding: 0 3px 3px 0;
}

.traceability-input ::v-deep .el-input__inner{
  border: 0;
  background-color: transparent;
}

.traceability-dialog-footer {
  display: flex;
  justify-content: end;
}
</style>